import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Box,
  Divider,
  Button,
  Menu,
  Grid,
  Stack,
  Paper,
  Avatar,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { createTheme, styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Dashboard from "../../assets/icons/Dashboard.svg";
import Checklist from "../../assets/icons/Checklist.svg";
import Defects from "../../assets/icons/Defects.svg";
import Repairs from "../../assets/icons/Repairs.svg";
import Masters from "../../assets/icons/Masters.svg";
import Account from "../../assets/icons/Account.svg";
import DashboardActive from "../../assets/icons/DashboardActive.svg";
import ChecklistActive from "../../assets/icons/ChecklistActive.svg";
import DefectsActive from "../../assets/icons/DefectsActive.svg";
import RepairsActive from "../../assets/icons/RepairsActive.svg";
import MastersActive from "../../assets/icons/MastersActive.svg";
import AccountActive from "../../assets/icons/AccountActive.svg";
import ArrowLeftActive from "../../assets/icons/Arrowleftactive.svg";
import Search from "../../assets/icons/Search.svg";
import Flag from "../../assets/icons/Flag.svg";
import { useDispatch, useSelector } from "react-redux";
import { TOKEN, REFRESHTOKEN } from "../../utils/localStorage";
import { getCookie } from "cookies-next";
import Profile from "../../assets/images/Profile.png";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {
  userLogOut,
  setLoaderUserLogOut,
  getNotificationData,
  setLoaderNotification,
  updateNotificationData,
} from "../../redux/actions/userActions";
import GenerateDefectId from "../../utils/GenerateDefectId";
import moment from "moment";

const drawerWidth = 220;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const hasPermission = (userPermissions, screenName) => {
  const permission = userPermissions?.find(
    (permission) =>
      permission?.screen?.name === screenName && permission?.screen?.active
  );

  if (permission?.active) {
    if (permission) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

const Sidebar = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLogOutLoading = useSelector((state) => state?.user?.isLogOutLoading);
  const accountDetailsData = useSelector(
    (state) => state?.account?.accountDetailsData
  );
  const userData = useSelector((state) => state?.user?.userData);
  const isUserLogout = useSelector((state) => state?.user?.isUserLogout);

  const notificationData = useSelector(
    (state) => state?.user?.notificationData
  );
  const isNotificationLoading = useSelector(
    (state) => state?.user?.isNotificationLoading
  );
  console.log("hlkhglkhdglkdhj", userData?.role?.name);
  // const [open, setOpen] = useState(JSON.parse(localStorage.getItem("sidebar")));

  const theme = useTheme();
  const storedValue = localStorage.getItem("sidebar");
  // Check if the screen size is xs or width is less than 600px
  // const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const isWidthLessThan600px = useMediaQuery("(max-width:600px)");

  const initialOpenState =
    storedValue === null ? true : JSON.parse(storedValue);

  const [open, setOpen] = useState(
    isWidthLessThan600px ? false : initialOpenState
  );

  const handleDrawerOpen = () => {
    localStorage.setItem("sidebar", open ? false : true);
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    localStorage.setItem("sidebar", open ? false : true);

    setOpen(false);
  };
  const sidebarmenu = [
    {
      name: "Dashboard",
      icon: Dashboard,
      ActiveIcon: DashboardActive,
      path: "/dashboard",
      active: true,
    },
    {
      name: "Checklist",
      icon: Checklist,
      ActiveIcon: ChecklistActive,
      path: "/checklist",
      active:
        userData?.role?.name === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Checklist_Menu"),
    },
    {
      name: "Defects",
      icon: Defects,
      ActiveIcon: DefectsActive,
      path: "/defects",
      active:
        userData?.role?.name === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Defects_Menu"),
    },
    {
      name: "Repairs",
      icon: Repairs,
      ActiveIcon: RepairsActive,
      path: "/repairs",
      active:
        userData?.role?.name === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Repairs_Menu"),
    },
    {
      name: "Masters",
      icon: Masters,
      ActiveIcon: MastersActive,
      path: "/masters",
      active:
        userData?.role?.name === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Masters_Menu"),
    },
    {
      name: "Account",
      icon: Account,
      ActiveIcon: AccountActive,
      path: "/account",
      active: true,
    },
  ];

  const [OpenNavigationPopUp, setOpenNavigationPopUp] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenNavigationPopUp = (event) => {
    dispatch(getNotificationData());
    setOpenNavigationPopUp(event.currentTarget);
  };

  const handleCloseNavigationPopUp = () => {
    // const NotificationDataIDS = notificationData
    //   .filter((item) => item.is_read === false)
    //   .map((item) => item.id);
    // if (NotificationDataIDS?.length !== 0 && !isNotificationLoading) {
    //   dispatch(
    //     updateNotificationData({
    //       ids: NotificationDataIDS,
    //     })
    //   );
    // }
    setOpenNavigationPopUp(null);
  };


  const handleUnReadNotification = (NotificationID) => {
    const NotificationDataIDS = notificationData
      .filter((item) => item.is_read === false && item.id === NotificationID)
      .map((item) => item.id);
    if (NotificationDataIDS?.length !== 0 && !isNotificationLoading) {
      dispatch(
        updateNotificationData({
          ids: NotificationDataIDS,
        })
      );
    }
  };

  // const activeScreens = sidebarmenu.filter((item) => hasPermission(userData?.userRolePermission, `${item.name}_Menu`));

  const handleLogOut = () => {
    const Token = getCookie(TOKEN);
    const RefreshToken = getCookie(REFRESHTOKEN);
    dispatch(
      userLogOut({
        refresh_token: RefreshToken,
        access_token: Token,
      })
    );
  };

  useEffect(() => {
    if (isUserLogout) {
      navigate("/");
    }
  }, [isUserLogout]);

  useEffect(() => {
    dispatch(getNotificationData());
    dispatch(setLoaderUserLogOut(false));
    dispatch(setLoaderNotification(false));
  }, []);

  const UnreadNotification = notificationData
    ?.filter((item) => item.is_read === false)
    ?.map((item) => item.id);

  return (
    <Box sx={{ display: "flex", m: 0, p: 0 }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        sx={{ backgroundColor: "#FFFFFF", height: "70px" }}
      >
        <Toolbar sx={{ p: 2 }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon sx={{ color: "#26875C" }} />
          </IconButton>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100vw",
            }}
          >
            <Box>
              <Typography variant="h6" sx={{ color: "#434349" }}>
                {props.title}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <Box sx={{ marginRight: "10px", marginTop: "5px" }}>
                <img src={Search} width="24" height="24" />
              </Box> */}
                <Box sx={{ marginRight: "20px" }}>
                  <IconButton onClick={handleOpenNavigationPopUp}>
                    <Badge
                      badgeContent={UnreadNotification?.length}
                      color="success"
                    >
                      <NotificationsIcon color="action" />
                    </Badge>
                  </IconButton>
                </Box>
              
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={OpenNavigationPopUp}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(OpenNavigationPopUp)}
                onClose={handleCloseNavigationPopUp}
              >
                <Box sx={{ padding: "5px 1px 5px 10px" }}>
                  <Grid
                    sx={{
                      // marginBottom: "25px",
                      overflow: "auto",
                      height: "25rem",
                      width: "20rem",
                      // padding: "0px 10px 0px 10px",
                      "&::-webkit-scrollbar": {
                        width: "5px",
                        height: "3px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#20724E",
                        borderRadius: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#E5F1EB",
                      },
                    }}
                  >
                    {isNotificationLoading ? (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "25rem",
                          width: "20rem",
                        }}
                      >
                        <CircularProgress color="success" />
                      </Grid>
                    ) : notificationData?.length === 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "25rem",
                          width: "20rem",
                        }}
                      >
                        <Typography
                          sx={{ fontWeight: "600", fontSize: "18px" }}
                        >
                          No Found Notifications
                        </Typography>
                      </Box>
                    ) : (
                      notificationData?.map((row, index) => (
                        <Grid item xs={12} key={row?.id}>
                          <Stack direction="row" alignItems="center">
                            <Paper
                              sx={{
                                margin: "5px 0px 5px 0px",
                                padding: "10px",
                                width: "19rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (row?.notification_type !== null) {
                                  if (row?.notification_type === "checklist") {
                                    handleUnReadNotification(row?.id);
                                    navigate("/checklist");
                                  } else if (
                                    row?.notification_type === "vessel"
                                  ) {
                                    handleUnReadNotification(row?.id);
                                    navigate("/masters/vesseladminmaster");
                                  } else if (
                                    row?.notification_type === "support"
                                  ) {
                                    handleUnReadNotification(row?.id);
                                    navigate("/masters/supportmaster");
                                  } else if (
                                    row?.defect_report_id === null &&
                                    row?.notification_type === "defects"
                                  ) {
                                    handleUnReadNotification(row?.id);
                                    navigate("/defects");
                                  } else if (
                                    row?.defect_report_id !== null &&
                                    row?.notification_type === "defects"
                                  ) {
                                    if (
                                      window.location.pathname ===
                                      "/defects/viewdefectdetails"
                                    ) {
                                      handleUnReadNotification(row?.id);
                                      window.location.reload();
                                      navigate("/defects/viewdefectdetails", {
                                        state: {
                                          DefectsRowData: row?.defect_report_id,
                                        },
                                      });
                                    } else {
                                      handleUnReadNotification(row?.id);
                                      navigate("/defects/viewdefectdetails", {
                                        state: {
                                          DefectsRowData: row?.defect_report_id,
                                        },
                                      });
                                    }
                                  }
                                }
                              }}
                            >
                              <Box sx={{ display: "flex", gap: "5px" }}>
                                <Typography sx={{ fontWeight: 600 }}>
                                  {row?.title}
                                </Typography>
                                {/* <Typography
                                  sx={{
                                    color:
                                      row?.is_read === true ? "#949494" : null,
                                  }}
                                >
                                  {GenerateDefectId(
                                    row?.defect_report_info?.vessel?.name,
                                    row?.defect_report_info?.display_id
                                  )}
                                </Typography> */}
                              </Box>
                              <Box>
                                <Typography
                                  sx={{
                                    color:
                                      row?.is_read === true ? "#949494" : null,
                                  }}
                                >
                                  {row?.descriptions}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    color:
                                      row?.is_read === true ? "#949494" : null,
                                  }}
                                >
                                  {moment(row?.createdAt).format(
                                    "D MMMM, YYYY | hh:mm A"
                                  )}
                                </Typography>
                              </Box>
                            </Paper>
                          </Stack>
                        </Grid>
                      ))
                    )}
                  </Grid>
                </Box>
              </Menu>
              <Box
                onClick={handleOpenUserMenu}
                sx={{ borderRadius: "20px !important" }}
              >
                <Avatar
                  alt="Remy Sharp"
                  src={
                    accountDetailsData?.profile_image ||
                    userData?.profile_image ||
                    Profile
                  }
                />

                {/* <Typography
                  align="center"
                  sx={{
                    color: "#0BB783",
                    fontSize: "20px",
                  }}
                >
                  {userData?.first_name?.charAt(0).toUpperCase()}
                </Typography> */}
              </Box>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <Box sx={{ padding: "20px 80px 20px 80px" }}>
                  <Typography align="center" sx={{ fontSize: "18px" }}>
                    {accountDetailsData?.first_name || userData?.first_name}
                  </Typography>
                  <Typography align="center" sx={{ fontSize: "13px" }}>
                    {accountDetailsData?.email || userData?.email}
                  </Typography>
                  <Typography align="center" sx={{ fontSize: "13px" }}>
                    {
                      <span
                        dangerouslySetInnerHTML={{
                          __html: `${
                            accountDetailsData?.first_name ||
                            userData?.first_name
                          } ${
                            accountDetailsData?.last_name || userData?.last_name
                          }`,
                        }}
                      />
                    }
                  </Typography>
                  <Typography
                    align="center"
                    sx={{
                      marginTop: "5px",
                      fontSize: "15px",
                      color: "#26875C",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/account");
                    }}
                  >
                    Edit Profile
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "15px",
                    }}
                  >
                    <LoadingButton
                      onClick={handleLogOut}
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        width: "7rem",
                        border: "1px solid #464E5F",
                        padding: "5px 5px 5px 5px",
                        borderRadius: "7px",
                        color: "#464E5F",
                      }}
                      loading={isLogOutLoading}
                    >
                      Log Out
                    </LoadingButton>
                  </Box>
                </Box>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        open={open}
        sx={{
          display: { sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            backgroundColor: "#1E1E2D",
          },
        }}
      >
        <DrawerHeader sx={{ background: "#1B1B28" }}>
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                fontWeight: "bold",
                color: "white",
                textAlign: "center",
                margin: "20px 0px 20px 0px",
                ...(!open && { display: "none" }),
              }}
            >
              {/* Planned Maintenance System <br /> */}
              PMS
            </Typography>
          </Box>
          <IconButton onClick={handleDrawerClose}>
            <img src={ArrowLeftActive} width="24" height="24" />
          </IconButton>

          {/* <IconButton>
            {theme.direction !== "rtl" ? (
              <Box onClick={handleDrawerOpen}>
                <img src={Account} width="24" height="24" />
              </Box>
            ) : (
              <Box onClick={handleDrawerClose}>
                <img src={ArrowLeftActive} width="24" height="24" />
              </Box>
            )}
          </IconButton> */}
        </DrawerHeader>
        <Divider />
        <List>
          {sidebarmenu.map((row) => {
            return row.active ? (
              <ListItem
                key={row?.name}
                disablePadding
                sx={{ display: "block" }}
              >
                <ListItemButton
                  onClick={() => {
                    navigate(row?.path);
                  }}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={
                        props.activeTab === row?.name
                          ? row?.ActiveIcon
                          : row.icon
                      }
                      alt={row.name}
                      width="24"
                      height="24"
                      // Add any other styling if needed
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={row?.name}
                    sx={{
                      color:
                        props.activeTab === row?.name ? "#FFFFFF" : "#888C9F",
                      fontSize: "13px",
                      opacity: open ? 1 : 0,
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ) : null;
          })}
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};

export default Sidebar;
